module.exports = __webpack_public_path__ + "img/图片5.7d5014e1.png";